module.exports = __webpack_public_path__ + "static/img/1.272021d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/1.jpg
// module id = xmmR
// module chunks = 1